import React from "react";
import "datatables.net-bs4/js/dataTables.bootstrap4";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import Flashsaleeditcontent from "./Flashsaleeditcontent";

export const Content = (props) => {
  return (
    <div className="ms-content-wrapper">
      <div className="row">
        <div className="col-md-12">
          <Flashsaleeditcontent/>
        </div>
      </div>
    </div>
  );
};

export default Content;
